<template lang="html">
  <div class="chat-wrapper">
    <div class="card-wrapper">
      <div class="card-header">
  <!--------------------->
       <div class="mainDataimgM">
         <div class="userImg">
              <img v-if='userData.usr_image' :src='imageLink(userData.usr_image)'>
              <img v-else src='@/assets/images/defaultProfileImage.png'>
          </div>
          <div class="mainDataM">
            <p class="dataName">{{userData.usr_name}} {{userData.usr_username}} </p>
              <p class="dataMail">{{userData.usr_email}} </p>
        </div>
     </div>
 <!---------------------->
      </div>
      <div @scroll="chatScrolled" class="card-messages" ref="chatWrap">
        <div class="msgs-wrapper" :class="{ 'my-msg' : msg.sender === 1 || msg.sender === msg.usr_id_from }" v-for="msg in messages" :key="msg.msg_id">
          <div :class="{ 'my-msg' : msg.sender === 1 || msg.sender === msg.usr_id_from }" class="message">
            <span v-if="msg.msg_file" class="msg-link msg">
              <a :href="getMsgUrl(msg.msg_file)">{{$t('main.downloadFile')}}</a>
            </span>
            <span class="msg">{{msg.msg_message}}</span>
            <span class="msg-time">{{$moment.utc(msg.msg_date).local().format("h:mm")}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="card-wrapper reply">
      <div class="reply">
        <div class="send-wrapper">
          <label for="msgFile">
            <img src="@/assets/icons/attachIcon.png" alt="attach icon">
          </label>
          <input @change="setFile($event)" type="file" id="msgFile" name="msgFile">
          <input v-if="getMsgFile === null" @keyup.enter="sendMsg" v-model="msg" :placeholder="$t('main.typeMessage')" type="text" name="" value="">
          <span v-else>
            {{getMsgFile.name}}
            <img @click="removeFile()" src="@/assets/icons/closeBadge.png" alt="close icon">
          </span>
        </div>
        <div @click="sendMsg" class="btn">
          {{$t('main.send')}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '@/shared/eventBus.js'
import { mapState } from 'vuex'
import { api, baseURL } from '@/api'
export default {
  name: 'chat',
  props: {
    chat: {
      required: true
    }
  },
  data () {
    return {
      msg: '',
      oldScroll: 10000,
      firstLoad: true,
      userData: {},
      msgFile: null
    }
  },
  async mounted () {
    this.getUserData(this.chat)
    await this.getChat()
    eventBus.$on('handleMessage', e => {
      this.onMessage(e, this.chat)
    })
    this.$store.commit('setChatVisible', true)
  },
  methods: {
    onMessage (evt, user) {
      console.log(evt, 'onmessage')
      try {
        let newMsg = JSON.parse(evt.data)
        if (newMsg.usr_id_from === user || newMsg.usr_id_to === user) {
          this.messages.push(newMsg)
          this.$nextTick(() => {
            let elem = this.$refs.chatWrap
            console.log(elem.scrollTop + 82, elem.scrollHeight - elem.offsetHeight);
            if (elem.scrollTop + 82 === (elem.scrollHeight - elem.offsetHeight)) {
              this.scrollToBottom()
              let params = {
                id: this.chat
              }
              api.seenUserMessages(params).then(() => {
                eventBus.$emit('refreshMessages')
              }).catch(e => { console.log(e) })
            }
          })
          eventBus.$emit('refreshMessages')
        } else {
          eventBus.$emit('refreshMessages')
        }
      } catch (e) {
        console.log(e, 'failed to parse new msg')
      }
    },
    setFile (e) {
      if (e.target.files[0]) {
        if(e.target.files[0].size > 15000000){
           e.target.value = null;
           this.msgFile = null
           this.$toast.error(this.$t('main.bigFile'), {
             duration: 8000
           })
        } else {
          this.msgFile = e.target.files[0]
        }
      } else {
        this.msgFile = null
      }
    },
    removeFile () {
      this.msgFile = null
      let el = document.querySelector('#msgFile')
      el.value = null
    },
    getMsgUrl (url) {
      return baseURL + url + '?sid=' + localStorage.getItem('sid')
    },
    sendMsg () {
      if (this.msgFile) {
        let params = new FormData()
        params.append('msg_file', this.msgFile)
        params.append('usr_id_to', this.chat)
        api.sendFile(params).then(() => {
          this.removeFile()
          this.getChat()
        }).catch(() => {
          this.removeFile()
          this.getChat()
        })
      } else {
        let params = {
          msg_message: this.msg,
          usr_id_to: this.chat
        }
        this.msg = ''
        this.connection.send(JSON.stringify(params))
      }
    },
    chatScrolled (e) {
      if (this.requestingMessages) {
        return
      }
      if (e.target.scrollTop < 10) {
        let params = {
          last_message: this.messages[0].msg_id,
          id: this.chat
        }
        this.$store.dispatch('loadMessagesHistory', params)
      }
    },
    async getChat () {
      await this.$store.dispatch('getMessages', this.chat)
      this.$refs.chatWrap.scrollTo({ top: this.$refs.chatWrap.scrollHeight })
    },
    scrollToBottom () {
      this.$refs.chatWrap.scrollTop = this.$refs.chatWrap.scrollHeight
    },
    imageLink (image) {
      return baseURL + image
    },
    getUserData (id) {
      let params = {
        id: id
      }
      api.getUserInfo(params).then(res => {
        console.log(res.data.data)
        this.userData = res.data.data
      })
    }
  },
  computed: {
    ...mapState(['connection', 'messages', 'requestingMessages']),
    getMsgFile () {
      return this.msgFile
    }
  },
  watch: {
    chat: {
      handler: function () {
        this.getUserData(this.chat)
        this.firstLoad = true
        this.getChat()
        this.msg = ''
      }
    }
  },
  destroyed () {
    eventBus.$off('handleMessage')
    this.$store.commit('setChatVisible', false)
  }
}
</script>

<style lang="scss" scoped>
.chat-wrapper {
  padding-left: 40px;
  @import '@/assets/scss/btnStyles.scss';

  .card-wrapper {
    width: 400px;
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.08);
    margin-bottom: 17px;
    position: relative;

    .card-header {
      height: 74px;
      border-bottom: 1px solid #F4F4F4;
      padding: 15px;
      padding-top: 6px;
      box-sizing: border-box;
    }
    .card-messages {
      padding: 15px;
      height: 430px;
      overflow-y: auto;
      // justify-content: center;
      @import "@/assets/scss/scrollbarStyles.scss";
      @include scrollbar;
      box-sizing: border-box;
      .msgs-wrapper {
        width: 100%;
        display: flex;
        &.my-msg {
            justify-content: flex-end;
        }
      }
      .message {
        padding: 10px 15px;
        padding-bottom: 30px;
        position: relative;
        background: #F3F3F3;
        border-radius: 10px 10px 10px 0px;
        opacity: 0.6;
        margin-bottom: 20px;
        align-items: flex-start;
        max-width: calc(100% - 30px);
        overflow: hidden;
        word-break: break-word;
        align-self: flex-start;
        justify-self: flex-start;
        display: flex;
        flex-direction: column;

        &.my-msg {
            background: #FAEDEF;
        }
        .msg {
          margin-bottom: 5px;
          text-align: left;
          font-weight: 500;
          font-size: 13px;
          line-height: 17px;
          letter-spacing: 0.02em;
        }
        .msg-time {
          font-weight: 500;
          font-size: 11px;
          line-height: 13px;
          letter-spacing: 0.06em;
          position: absolute;
          bottom: 10px;
          right: 10px;
        }
        .msg-link {
          margin-bottom: 10px;
        }
      }
    }
    .reply {
      display: flex;
      flex-direction: row;

      .send-wrapper {
        flex-grow: 1;
        display: flex;
        align-items: center;

        img {
          cursor: pointer;
        }
        #msgFile {
          display: none;
        }
      }
    }
  }
  .card-wrapper.reply {
    padding: 15px;
    box-sizing: border-box;
    height: auto;
    img {
      margin-right: 15px;
    }
    input {
      flex-grow: 1;
      border: none;
      margin-right: 15px;
      outline: none;
      width: 100%;
    }
  }
  .mainDataimgM{
    display: flex;
     .userImg {
          width: 60px;
          height: 60px;
          overflow: hidden;
          border-radius: 6px;
          margin-bottom: 40px;

          img {
            width: 100%;
          }
        }

    .mainDataM{
      padding-left: 20px;
      text-align: left;
      .dataName{
        margin-bottom:5px;
      }
      .dataMail{
        margin-top: 0 !important;
        font-family: Catamaran;
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        /* identical to box height */

        letter-spacing: 0.06em;

        color: #9E9E9E;

      }
    }
  }
}
@media only screen and (max-width: 1200px){
  .chat-wrapper {
    padding-left: 0px;

    .card-wrapper {
      width: 100%;
    }

    .reply {
      flex-wrap: wrap;
    }
  }
}
</style>
